/**
 * Keep in sync with hct-webapp `src/core/case-history/ageFilterWirePages.ts`.
 */

export type ShowForAgeDays = {
  min?: number;
  max?: number;
};

export type WhenMissingDob = "all" | "universalOnly";

export function pageInAgeRange(
  showForAge: ShowForAgeDays | null | undefined,
  ageInDays: number
): boolean {
  if (showForAge == null) return true;

  const minEff = showForAge.min !== undefined ? Math.max(0, Math.floor(showForAge.min)) : 0;
  if (ageInDays < minEff) return false;

  if (showForAge.max !== undefined) {
    const maxEff = Math.max(0, Math.floor(showForAge.max));
    if (ageInDays > maxEff) return false;
  }

  return true;
}

/**
 * Filter wire `pages[]` items; when DOB is missing, show all pages (`whenMissingDob: 'all'`).
 */
export function filterWirePageRecords<T extends { showForAgeDays?: ShowForAgeDays | null }>(
  pages: T[] | undefined,
  ageInDays: number | null,
  options?: { whenMissingDob?: WhenMissingDob }
): T[] {
  if (!pages?.length) return [];
  const whenMissingDob: WhenMissingDob = options?.whenMissingDob ?? "all";

  if (ageInDays == null) {
    if (whenMissingDob === "all") return pages;
    return pages.filter((p) => p.showForAgeDays == null);
  }

  return pages.filter((p) => pageInAgeRange(p.showForAgeDays, ageInDays));
}
